import React from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Panel from '../../../../../components/outline/Panel';
import { RECOMMEND_PRODUCT_TYPE_TEXT } from '../../../../../constants/service/app/recommendProductConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';

const RecommendProductDetailInfo = (props) => {
  const { recommendProductInfo } = props;
  const { adminName, type, createDate, memo } = recommendProductInfo;

  return (
    <Panel className="recommend-product-detail-info">
      <div className="panel-header">
        <div className="title">추천 상품 정보</div>
      </div>

      <div className="panel-body">
        {/* 추천인 */}
        <BaseForm label="추천인" content={adminName ? adminName : '스케줄러'} />

        {/* 추천 상품 타입 */}
        <BaseForm label="추천 상품 타입" content={RECOMMEND_PRODUCT_TYPE_TEXT[type]} />

        {/* 추천 상품 생성일 */}
        <BaseForm label="추천 상품 생성일" content={setDateFormat(createDate, DATE_FORMAT.FULL_DASH_FORMAT)} />

        {/* 메모 */}
        <BaseForm label="메모" content={memo} />
      </div>
    </Panel>
  );
};

export default RecommendProductDetailInfo;
